import { notify } from "./Notify";
import { NotifyType } from "./NotifyType";

export const errorLogging = () => {
  const { message } = notify();

  const handleHttpError = (error: any, showMessage: boolean = false) => {
    if (error.response) {
    } else if (error.request) {
    } else {
    }
    if (showMessage) {
      message(NotifyType.Error, "Something went wrong!");
      throw new Error("something went wrong"); // no response received by the api service
    }
  };

  return {
    handleHttpError: handleHttpError,
  };
};
